import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { IClientApiDependencySegment, catchApiError } from '@cbridge-packages/api';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { PriceFilteringAction } from '../priceFiltering.action';
import { PriceFilteringTranslator } from '../priceFiltering.translator';

type IDependencies = IClientApiDependencySegment;

export const loadPriceFilteringListEpic: IEpic<{}, IDependencies> = (action$, _, dependencies) => action$.pipe(
  isTypeOfAndGetPayload(PriceFilteringAction.loadList.started),
  mergeMap(() => {
    return dependencies.api.getPriceFilteringProfileList({}).pipe(
      mergeMap((response) => {
        const result = {
          data: (response.profiles ?? []).map(PriceFilteringTranslator.fromApi),
          defaultData: PriceFilteringTranslator.defaultFromApi(response.default),
        };

        return [
          PriceFilteringAction.loadList.done({ result }),
        ];
      }),
      catchApiError((error) => {
        return [
          PriceFilteringAction.loadList.failed({ error }),
          createApiErrorNotification(error),
        ];
      }),
    );
  }),
);
